import { Box } from "@mui/material";
import LiveIssueStreamCard from "./LiveIssueStreamCard";
import MapCard from "./MapCard";

/**
 * Custom platform IssueStreamSection.
 *
 * Renders the Map (left 75%) and Live Issue Stream (right 25%) row.
 * Both are conditionally rendered based on the `widgets` array from
 * customDashboards[activeKey].overview.widgets.
 *
 * Map filter definitions and pin popup fields are read internally
 * by MapCard from customObservabilityConfig in AppCache.
 */
const IssueStreamSection = ({ globalFilters, widgets = [], liveIssueStreamConfig = {} }) => {
  const showMap = widgets.includes("overviewMap");
  const showIssueStream = widgets.includes("liveIssueStream");

  if (!showMap && !showIssueStream) return null;

  // Compute widths based on which widgets are active
  const mapWidth = showIssueStream ? "75%" : "100%";
  const streamWidth = showMap ? "25%" : "100%";

  return (
    <Box sx={{ display: "flex", alignItems: "stretch", gap: showMap && showIssueStream ? 2 : 0 }}>
      {showMap && (
        <Box sx={{ width: mapWidth, display: "flex" }}>
          <MapCard globalFilters={globalFilters} />
        </Box>
      )}
      {showIssueStream && (
        <Box sx={{ width: streamWidth, display: "flex" }}>
          <LiveIssueStreamCard globalFilters={globalFilters} config={liveIssueStreamConfig} />
        </Box>
      )}
    </Box>
  );
};

export default IssueStreamSection;
